'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _ = require('underscore'),
    events = require('../events');

module.exports = function (videojs) {
  var MenuItem = videojs.getComponent('MenuItem');
  /**
   * A MenuItem to represent a video resolution
   *
   * @class QualityOption
   * @extends videojs.MenuItem
   */

  return videojs.extend(MenuItem, {
    /**
     * @inheritdoc
     */
    constructor: function constructor(player, options) {
      var source = options.source;

      if (!_.isObject(source)) {
        throw new Error('was not provided a "source" object, but rather: ' + _typeof(source));
      }

      options = _.extend({
        selectable: true,
        label: source.label
      }, options);
      MenuItem.call(this, player, options);
      this.source = source;
    },

    /**
     * @inheritdoc
     */
    handleClick: function handleClick(event) {
      MenuItem.prototype.handleClick.call(this, event);
      this.player().trigger(events.QUALITY_REQUESTED, this.source);
    }
  });
};